import React from "react";
import "./NetworkErrorState.css";

export default function NetworkErrorState({ message, onRetry, title = "Connection problem" }) {
    return (
        <div className="network-error-state" role="alert" aria-live="assertive">
            <div className="network-error-state__card">
                <div className="network-error-state__icon-wrap" aria-hidden>
                    <svg
                        className="network-error-state__icon"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" opacity="0.35" />
                        <path
                            d="M32 18v8M32 38v8M18 32h8M38 32h8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <circle cx="32" cy="32" r="6" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </div>
                <h1 className="network-error-state__title">{title}</h1>
                <p className="network-error-state__message">{message}</p>
                {onRetry ? (
                    <button type="button" className="network-error-state__retry btn" onClick={onRetry}>
                        Try again
                    </button>
                ) : null}
            </div>
        </div>
    );
}
